// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-panel-domain-check-simple tld-price-list=\"$ctrl.tldPriceList\" small-view=\"true\"></molecule-panel-domain-check-simple> </div> </div> ";
// Exports
module.exports = code;